import React from "react";

const servicesCatalog = [
  {
    title: "Data Analytics",
    accent: "#FF6661",
    description:
      "Transform raw data into actionable intelligence. AI analytics bots uncover patterns, predict trends, and craft narratives from numbers."
  },
  {
    title: "Knowledge & Insights",
    accent: "#B86FFF",
    description:
      "Synthesize collective intelligence. Knowledge bots research, connect dots, and surface insights so your team can learn faster."
  },
  {
    title: "Productivity",
    accent: "#4D44DC",
    description:
      "Automate the repetitive. Productivity bots streamline workflows, guard context, and help humans focus on high-impact creativity."
  }
];

const styles = {
  leanSection: {
    maxWidth: 1100,
    margin: "32px auto",
    padding: "0 1.5rem",
    textAlign: "center"
  },
  sectionTitle: {
    margin: 0,
    fontSize: "2.5rem",
    fontWeight: 700,
    color: "white"
  },
  sectionSubhead: {
    marginTop: 8,
    color: "white",
    maxWidth: 760,
    lineHeight: 1.6,
    textAlign: "center",
    marginLeft: "auto",
    marginRight: "auto"
  },
  serviceGrid: {
    marginTop: 32,
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
    gap: 18,
    justifyContent: "center"
  },
  serviceCard: {
    border: "1px solid rgba(255,255,255,0.1)",
    borderRadius: 18,
    padding: "1.5rem",
    background: "rgba(255,255,255,0.03)",
    boxShadow: "0 20px 40px rgba(0,0,0,0.35)",
    minHeight: 200,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 8
  },
  cardTitle: {
    margin: 0,
    fontSize: "1.15rem",
    fontWeight: 600
  },
  cardText: {
    margin: 0,
    color: "#B0B6C7",
    fontSize: "0.95rem",
    lineHeight: 1.6
  }
};

const ServicesPage = () => (
  <section style={styles.leanSection}>
    <h2 style={styles.sectionTitle}>Services</h2>
    <p style={styles.sectionSubhead}>
      TwoDots AI services pair human insight with autonomous agents. The wheel points to one vibe, while these services power the actual work.
    </p>
    <div style={styles.serviceGrid}>
      {servicesCatalog.map((service) => (
        <article key={service.title} style={styles.serviceCard}>
          <h3 style={styles.cardTitle}>{service.title}</h3>
          <p style={styles.cardText}>{service.description}</p>
        </article>
      ))}
    </div>
  </section>
);

export default ServicesPage;
